export enum Distributions {
	Eager = 'Eager',
	Evenly = 'Evenly',
}

export type Distribution = Distributions.Eager | Distributions.Evenly;
